export function getRandomCoordinates(rows, columns) {
  return {
    row: Math.floor(Math.random() * rows),
    col: Math.floor(Math.random() * columns),
  };
}
